<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="进水瞬时流量测点"
              prop="waterinInstantflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.waterinInstantflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="出水瞬时流量测点"
              prop="wateroutInstantflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.wateroutInstantflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="进水累积流量测点"
              prop="waterinAccumulateflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.waterinAccumulateflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="出水累积流量测点"
              prop="wateroutAccumulateflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.wateroutAccumulateflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="进水水质测点组"
              prop="waterinQualityGroup"
            >
              <j-dict-select-tag
                :dictCode="pointsGroupDictCode"
                placeholder="请选择进水水质测点组"
                v-model="model.waterinQualityGroup"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="出水水质测点组"
              prop="wateroutQualityGroup"
            >
              <j-dict-select-tag
                :dictCode="pointsGroupDictCode"
                placeholder="请选择出水水质测点组"
                v-model="model.wateroutQualityGroup"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="回用水瞬时流量测点"
              prop="waterreuseInstantflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.waterreuseInstantflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="回用水累积流量测点"
              prop="waterreuseAccumulateflowPoint"
            >
              <j-select-model-points
                :multiple="false"
                placeholder="请选择测点"
                v-model="model.waterreuseAccumulateflowPoint"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="回用水水质测点组"
              prop="waterreuseQualityGroup"
            >
              <j-dict-select-tag
                :dictCode="pointsGroupDictCode"
                placeholder="回用水水质测点组"
                v-model="model.waterreuseQualityGroup"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="蒸汽量测点" prop="steamPoint">
              <j-select-model-points :multiple="false" placeholder="请选择测点" v-model="model.steamPoint" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="泥量测点" prop="mudPoint">
              <j-select-model-points :multiple="false" placeholder="请选择测点" v-model="model.mudPoint" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <a-row>
      <a-col :span="22"></a-col>
      <a-col :span="2">
        <a-form-item>
          <a-button :loading="confirmLoading" @click="submitForm()" type="primary">保存</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'

export default {
  name: 'SewagePlantInoutConfForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      pointsGroupDictCode: `\`iwt-app\`.iot_model_points_group,group_name,id,del_flag='0' and user_id = '${this.$store.getters.userInfo.id}'`,
      confirmLoading: false,
      validatorRules: {},
      url: {
        list: '/monitor/sewagePlantInoutConf/list',
        add: '/monitor/sewagePlantInoutConf/add',
        edit: '/monitor/sewagePlantInoutConf/edit',
        queryById: '/monitor/sewagePlantInoutConf/queryById'
      }
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
    this.loadData()
  },
  methods: {
    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    loadData() {
      getAction(this.url.list, {}).then(res => {
        if (res.success) {
          const originMedel = res.result.records[0]
          if (originMedel) {
            this.model = originMedel
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
